(function () {
  var wrap = document.querySelector('[data-luma-cart]');
  if (!wrap) return;
  var body = wrap.querySelector('[data-luma-cart-body]');
  var foot = wrap.querySelector('[data-luma-cart-foot]');
  var subEl = wrap.querySelector('[data-luma-cart-sub]');
  var countEl = wrap.querySelector('[data-luma-cart-count]');
  var shipWrap = wrap.querySelector('[data-luma-ship]');
  var shipText = wrap.querySelector('[data-luma-ship-text]');
  var shipBar = wrap.querySelector('[data-luma-ship-bar]');
  var threshold = parseInt(wrap.getAttribute('data-threshold') || '0', 10);
  var mixedEl = wrap.querySelector('[data-luma-mixed]');
  var noteEl = wrap.querySelector('[data-luma-note]');

  function vendorCount(items) {
    var seen = {};
    (items || []).forEach(function (it) {
      if (it.requires_shipping !== false && it.vendor) seen[String(it.vendor).toLowerCase()] = true;
    });
    return Object.keys(seen).length;
  }

  function money(cents) { return '$' + (cents / 100).toFixed(2); }

  function thumb(url) {
    if (!url) return '';
    return url + (url.indexOf('?') === -1 ? '?' : '&') + 'width=200';
  }

  function esc(s) {
    return String(s == null ? '' : s)
      .split('&').join('&amp;')
      .split('<').join('&lt;')
      .split('>').join('&gt;')
      .split('"').join('&quot;');
  }

  function render(cart) {
    countEl.textContent = cart.item_count ? '(' + cart.item_count + ')' : '';
    if (!cart.items || !cart.items.length) {
      body.innerHTML = '<div class="luma-cart__empty"><p>Your cart is empty.</p><a href="/collections/best-sellers" class="button">Shop best sellers</a></div>';
      foot.hidden = true;
      if (shipWrap) shipWrap.hidden = true;
      return;
    }
    var html = '';
    cart.items.forEach(function (it, i) {
      html += '<div class="luma-cart__line">';
      html += it.image ? '<img src="' + esc(thumb(it.image)) + '" alt="" width="70" height="70" loading="lazy">' : '<div></div>';
      html += '<div><p class="luma-cart__name"><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a></p>';
      if (it.variant_title && it.variant_title !== 'Default Title') html += '<p class="luma-cart__opt">' + esc(it.variant_title) + '</p>';
      if (it.selling_plan_allocation) html += '<p class="luma-cart__opt">' + esc(it.selling_plan_allocation.selling_plan.name) + '</p>';
      html += '<div class="luma-cart__row"><span class="luma-cart__qty">';
      html += '<button type="button" data-luma-line="' + (i + 1) + '" data-luma-to="' + (it.quantity - 1) + '" aria-label="Decrease">&minus;</button>';
      html += '<span>' + it.quantity + '</span>';
      html += '<button type="button" data-luma-line="' + (i + 1) + '" data-luma-to="' + (it.quantity + 1) + '" aria-label="Increase">+</button>';
      html += '</span><span class="luma-cart__lineprice">' + money(it.final_line_price) + '</span></div>';
      html += '<button type="button" class="luma-cart__remove" data-luma-line="' + (i + 1) + '" data-luma-to="0">Remove</button>';
      html += '</div></div>';
    });
    body.innerHTML = html;
    subEl.textContent = money(cart.total_price);
    foot.hidden = false;

    var mixed = vendorCount(cart.items) > 1;
    if (mixedEl) mixedEl.hidden = !mixed;
    if (noteEl) noteEl.hidden = mixed && !!mixedEl;

    if (shipWrap && threshold > 0) {
      shipWrap.hidden = false;
      var left = threshold - cart.total_price;
      if (left > 0) {
        shipText.textContent = 'You are ' + money(left) + ' away from free shipping';
        shipBar.style.width = Math.min(100, (cart.total_price / threshold) * 100) + '%';
      } else {
        shipText.textContent = 'Free shipping unlocked';
        shipBar.style.width = '100%';
      }
    }

    body.querySelectorAll('[data-luma-line]').forEach(function (b) {
      b.addEventListener('click', function () {
        change(b.getAttribute('data-luma-line'), b.getAttribute('data-luma-to'));
      });
    });
  }

  function load() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {});
  }

  function change(line, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: Number(line), quantity: Number(quantity) })
    })
      .then(function (r) { return r.json(); })
      .then(render)
      .catch(function () {});
  }

  function open() {
    wrap.setAttribute('data-open', 'true');
    wrap.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    load();
  }
  function close() {
    wrap.setAttribute('data-open', 'false');
    wrap.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  window.lumaOpenCart = open;
  wrap.querySelectorAll('[data-luma-cart-close]').forEach(function (b) { b.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  document.addEventListener('luma:cart:changed', load);

  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('a[href="/cart"]') : null;
    if (a && !a.closest('[data-luma-cart]')) { e.preventDefault(); open(); }
  });

  load();
})();